// Important: This file is auto generated! Do not manually edit or checkin!
    const VERSION = 'v1.151026g';
    export default VERSION;